var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41009 12.254C8.41009 13.832 7.12435 15.1112 5.5383 15.1112C3.95225 15.1112 2.6665 13.832 2.6665 12.254C2.6665 10.6761 3.95225 9.39688 5.5383 9.39688C7.12435 9.39688 8.41009 10.6761 8.41009 12.254ZM8.41009 12.254V5.58736M8.41009 6.53974V1.77783L8.98445 2.53974C10.4307 4.45826 12.7005 5.58736 15.1109 5.58736",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.f5422a6324f5b2272a87a8895b3ebef8.svg";
export { ForwardRef as ReactComponent };